/*
 * @Author: your name
 * @Date: 2021-01-19 12:14:20
 * @LastEditTime: 2021-09-26 14:32:54
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \lavrock-official-platform\src\store\modules\template\template.state.js
 */
import _ from 'lodash'
const state = {
	projId: '',
	pageId: '',
	pageNavList: [],
	indexPageId: '',
	deleteNavList: [],
	// 插件
	pluginGroup: {},
	// 编辑窗口window对象
	templateWindow: null,
	// 编辑窗口jquery对象
	jquery: _.noop(),
	configFtp: {
		ftpId: '',
		isPlanDomain: ''
	},
	// 板块列表
	blockListIndex: [],
	blockListEnd: [],
	blockListMid: [],
	sectionListMid: [],
	// blockList: [],
	toolbarState: {
		isSave: false, //正在保存
		isSuccess: false, //保存成功
		isResult: false, //jiazai成功
		isLoading: false, //加载成功
		isFail: false
	},
	showSlideIcon: false, //控制左侧操作栏展开与现实
	showOnline: false, // 上线内容弹窗
	showChecker: false, // 检测弹窗
	showVideo: false, // 观看视频弹窗
	showResult: false, //检测结果
	isChecking: false, //是否正在检测
	taskId:'', //发布检测taskId，每次发布更新一次
	showConfig: false,
	showMeitu: false,
	/*
	 * 前进回退
	 * */
	history: {
		prevFalg: false,
		nextFalg: false
	},
	projInfo: {},
	launchStatus: '',
	pageUrl: '',
	iframeWidth: 'pc',
	categoryId: '', //平台素材当前选中的目录
	imgSize: [],
	webConfigCurTabs: 'concatInfo',
	accountInfo: {},
	categoryPageData: [], //分类页
	pageSelectCur: {},
	pageSelectData: {},
	dataSelectShow: false,
	showBuySite: false,
	bannerOriginSize: '',
	allTimingData:[],//全部定时数据
	setPermissions:{} //套餐权限
}

export default state
